import { filter } from 'rxjs/operators';
export function filterNull() {
    return filter((input) => input !== null && input !== undefined);
}
//# sourceMappingURL=filter_null.js.map